module.exports = __webpack_public_path__ + "static/img/stairs-right_256.98ae0e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stairs-right_256.png
// module id = YVTI
// module chunks = 0